import styled, {keyframes} from "styled-components";

const invalidInput = keyframes`
0% {transform: skew(-15deg)}
25% { transform: skew(15deg)}
50% {transform: skew(-15deg)}
100% { transform: skew(0deg)}

`

export const  General = {
    Background: styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${({ backgroundColor }) => backgroundColor};
    border-radius: 1rem;
    margin: 4rem;
    `,
    Heading: styled.h1`
        color: ${({ color }) => color};
        margin: 1rem;
    `,
    Legend: styled.legend`
    background-color: #000;
    color: #fff;
    padding: 3px 6px;
    `,
    Input: styled.input`
    // margin: 1rem; // using margin screws up the InputCont flex 
    padding: 1rem;
    border-radius: 0.5rem;
    &:invalid {
        border: 2px dashed ${({theme}) => theme.colors.errorRed};
    }
    max-width: 20rem;
    `,
    Label: styled.label`
    position: absolute;
    top: 1rem;
    left: 0.8rem;
    font-size: 1.4rem;
    padding: 0 .5rem;
    transition: 0.3s;
    pointer-events: none;
    `,
    BlockContainer: styled.div`
    width: ${({width}) => width || '610px'};
    display: flex;
    flex-direction: row;
    align-items: ${({align}) => align || 'flex-start'};
    justify-content:${({justify}) => justify || 'normal'};
    flex-wrap: wrap;
    @media screen and (max-width:${({ theme }) => theme.mobile}) {
        flex-direction: row-reverse;
        }
    `,
    InputCont: styled.div`
    width: 100%;
    margin: ${({margin}) => margin || '1rem'};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
     .placeholder {
        position: absolute;
        top: 1rem;
        left: 0.8rem;
        font-size: 1.4rem;
        padding: 0 .5rem;
        transition: 0.3s;
        pointer-events: none;
    }
    p {
        color: ${({ theme }) => theme.colors.grey3};
        padding: 1rem;
    }
    span {
        font-weight: bold;
        padding: 1rem;
    }
    .input:focus + .placeholder, .input:not(:placeholder-shown) + .placeholder{
        top: -1rem;
        background-color: white;
    }
   
    `,

    Block: styled.div`
    margin: 1rem;
    display: flex;
    color: ${({ color }) => color}
    `,
    Select: styled.select`
    max-width: 25rem;
    font-family: inherit;
    padding: 1rem;
    border-radius: 0.5rem;
    text-overflow: ellipsis;
    border: 2px solid black;
    `,
    Text: styled.textarea`
    // margin: 1rem;
    padding: 1rem;
    border-radius: 0.5rem;
    min-width: 140px;
    border: 2px solid black;
    &:invalid {
        border: 2px dashed ${({theme}) => theme.colors.errorRed};
        // animation: ${invalidInput} .3s;
    }
    `,
    LimitText: styled.div`
    width: ${({width}) => width};
    font-weight: ${({weight}) => parseInt(weight)};
    `,
    Table: styled.table`
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
    border: 3px solid ${({theme}) => theme.colors.pdeOrange};
    td {
       padding: 2rem;
       text-align: center;
    }
    tbody tr:nth-child(odd) {
       background-color: ${({theme}) => theme.colors.grey1}
    }
    `,
    ColBlock: styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${({align}) => align || 'center'};
    justify-content:${({justify}) => justify || 'center'};
    width: ${({width}) => width || '100%'};
    height: ${({height}) => height || 'auto'};
    margin: ${({margin}) => margin || '0'};
    background-color: ${({bgColor}) => bgColor || 'white'};
    `,
    RowBlock: styled.div`
    display: flex;
    flex-direction: row;   
    align-items: ${({align}) => align || 'center'};
    justify-content:${({justify}) => justify || 'center'};
    width: ${({width}) => width || 'auto'};
    height: ${({height}) => height || 'auto'};
    background-color: ${({bgColor}) => bgColor || 'white'};
    `,
    BoldPara: styled.p`
    font-weight: bold;
    `,
    SmallHead: styled.h2`
    font-size: 1.4rem;
    text-transform: capitalize;
    background-color: transparent;
  `,
}
